<!-- 项目文件 -->
<template>
    <div class="w100p minw1260">
        
        <div class="bg1f8 h60 lh60">
            <div class="w1260 mauto overhidden">
                <span class="h60 floatl mr20 alit">
                    <img class="h22 w84" src="../../public/img/logo.png">
                    <router-link to="Aboutwe">
                        <span class="fs18 cfff pl10 ml10 lh30 h30 borderlfff disinblock">
                            关于我们
                        </span>
                    </router-link>
                </span>
                <ul class="disinblock floatl ml20">
                    <router-link to="/">
                        <li class="disinblock mr20 ml20 cfff fs14 floatl"> 首页 </li>
                    </router-link>
                    <router-link to="Aboutwe">
                        <li class="disinblock mr20 ml20 cfff fs14 floatl"> 公司简介 </li>
                    </router-link>
                    <router-link to="AboutNews">
                        <li class="disinblock mr20 ml20 cfff fs14 floatl"> 新闻动态 </li>
                    </router-link>
                    <router-link to="Recruitment">
                        <li class="disinblock mr20 ml20 cfff fs14 floatl"> 人才招聘 </li>
                    </router-link>
                    <router-link to="Contact">
                        <li class="disinblock mr20 ml20 cfff fs14 floatl"> 联系我们 </li>
                    </router-link>
                </ul>
                <div class="floatr">
                   
                    <a href="http://bdm.yixueyijia.com/bdNew/home" target="_blank">
                        <span class="br20 pt5 pb8 pl16 pr16 borderfff cfff fs14">
                            <i class="vermid  cfff fs14"> BD登录 </i>
                        </span>
                    </a>
                </div>
            </div>
        </div>
        <div class="w100p fs0">
            <img class=" w100p" :src="img">
        </div>
    </div>
</template>

<script>
    export default {
        props: ['img'],
        data() {
            return {

            };
        },

        methods: {

        },
        created() {},
        mounted() {

        },
    }
</script>
<style scoped>

</style>